
import { callAi } from "./geminiClient";

function getLang() {
  return (typeof document !== "undefined" && document.documentElement?.lang) || "ko";
}

/** 공통: 로그인 확인 (기존 전환 파일들과 동일 스타일) */
function ensureLoginOrThrow(lang) {
  const raw = (typeof localStorage !== "undefined" && localStorage.getItem("user")) || "";
  const user = raw ? JSON.parse(raw) : null;
  if (!user) {
    alert(lang === "zh-CN" ? "请先登录后再使用。" : "로그인 후 사용해 주세요");
    if (typeof window !== "undefined") window.location.href = "/login";
    throw new Error("NOT_AUTHENTICATED");
  }
  return user;
}

export const SmallTalkAI = {
  async generate({ record }) {
    const lang = getLang();
    const user = ensureLoginOrThrow(lang);

    let prompt = "";
    if (lang === "zh-CN") {
      prompt = `
                你是30多岁的女性，在 '${process.env.REACT_APP_CN_CLINIC_NAME}' 工作的非常亲切且有眼力见的职员。你的客户是40~60多岁的女性减肥患者，目标是不像单纯的职员，而是像舒适的妹妹或侄女一样真心沟通。
                请根据下面提供的患者最后诊疗记录，**摆脱现有陈腐的提问，提出3~4个更加丰富多彩且富有创意的闲聊话题。**

                **[生成指南]**
                1. **多样的接近:** 超越单纯的称赞，结合患者的生活方式、情感、微小的变化、周围的故事（例：天气、季节花卉）等，提出能给予意想不到快乐的问题。
                2. **具体的称赞:** 不是“做得很好”，而是像“在控制饮食的同时，发现新食谱的乐趣应该也很大吧！”一样，想象具体情况进行称赞。
                3. **积极的未来连接:** 请包含通过患者的努力描绘未来带来的积极变化（例：去旅行时步履更轻盈的样子）的温暖提问。
                4. **格式:** 每个问题以 '-' 开头，列出列表形式，请使用亲切温和的语气（中文）。绝对不要包含有负担或医学内容。

                [患者诊疗记录]
                ${record}
            `;
    } else {
      prompt = `
                당신은 30대 여성으로, '${process.env.REACT_APP_CLINIC_NAME}'에서 근무하는 매우 다정하고 센스 있는 직원입니다. 당신의 고객은 40~60대 여성 다이어트 환자이며, 단순한 직원이 아닌 편안한 동생이나 조카처럼 진심으로 소통하는 것을 목표로 합니다.
                아래 제공된 환자의 마지막 진료 기록을 바탕으로, **기존의 뻔한 질문에서 벗어나 훨씬 더 다채롭고 창의적인 스몰토크 주제 3~4개를 제안해주세요.**

                **[생성 가이드라인]**
                1.  **다양한 접근:** 단순한 칭찬을 넘어, 환자의 라이프스타일, 감정, 작은 변화, 주변 이야기(예: 날씨, 계절 꽃) 등과 연결하여 예상치 못한 즐거움을 주는 질문을 만들어주세요.
                2.  **구체적인 칭찬:** "잘하고 계세요"가 아닌, "식단 조절하시면서 새로운 레시피 발견하는 재미도 있으셨을 것 같아요!"처럼 구체적인 상황을 상상하며 칭찬해주세요.
                3.  **긍정적 미래 연결:** 환자의 노력이 앞으로 가져올 긍정적인 변화(예: 여행 가서 더 가볍게 걸으시는 모습)를 함께 그려주는 따뜻한 질문을 포함해주세요.
                4.  **형식:** 각 질문은 '-'로 시작하는 목록 형태로, 친근하고 상냥한 말투로 작성해주세요. 부담스럽거나 의학적인 내용은 절대 포함하지 마세요.

                [환자 진료 기록]
                ${record}
            `;
    }

    const contents = [{ role: "user", parts: [{ text: prompt }] }];

    const data = await callAi({
      contents,
      api_name: "small_talk", 
      userId: user.id,
      generationConfig: null,
      version: undefined,
    });

    // 가능한 응답 필드 호환 (텍스트 그대로 반환)
    const text =
      data?.data?.answer ??
      data?.answer ??
      data?.text ??
      data?.data?.text ??
      "";

    if (!text || typeof text !== "string") {
      throw new Error("AI 응답이 비어있습니다.");
    }

    return { text };
  },
};
